import Typography from '@mui/material/Typography';
import React from 'react';
// NOTE: SVGInline is deprecated and should be replaced - it doesnt support dynamic sizing well so we are using a React component instead
// This was converted from the raw SVG file located at '../../../images/all-done.svg.raw' and the tool SVGR (https://react-svgr.com/playground/) was used to generate the React component

const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 202 160"
    {...props}
  >
    <rect width={160} height={160} x={23.011} fill="#edf7ed" rx={80} />
    <g filter="url(#a)">
      <path
        fill="#fff"
        d="M54.755 62h135.718c1.333 0 2.612.527 3.555 1.465A5 5 0 0 1 195.5 67v25c0 1.326-.53 2.598-1.472 3.535A5.04 5.04 0 0 1 190.473 97H54.755a5.04 5.04 0 0 1-3.554-1.465A4.99 4.99 0 0 1 49.728 92V67c0-1.326.53-2.598 1.473-3.535A5.04 5.04 0 0 1 54.755 62"
      />
    </g>
    <path
      fill="#000"
      fillOpacity={0.5}
      d="M96.979 70H70.84a3.01 3.01 0 0 0-3.016 3c0 1.657 1.35 3 3.016 3h26.138a3.01 3.01 0 0 0 3.016-3c0-1.657-1.35-3-3.016-3"
    />
    <path
      fill="#000"
      fillOpacity={0.2}
      d="M115.074 83H70.84a3.01 3.01 0 0 0-3.016 3c0 1.657 1.35 3 3.016 3h44.234a3.01 3.01 0 0 0 3.016-3c0-1.657-1.35-3-3.016-3"
    />
    <g filter="url(#b)">
      <path
        fill="#fff"
        d="M11.527 105h135.718c1.333 0 2.611.527 3.554 1.464a4.99 4.99 0 0 1 1.472 3.536v25a4.99 4.99 0 0 1-1.472 3.536 5.04 5.04 0 0 1-3.554 1.464H11.527a5.04 5.04 0 0 1-3.555-1.464A5 5 0 0 1 6.5 135v-25a4.99 4.99 0 0 1 1.472-3.536A5.04 5.04 0 0 1 11.527 105"
      />
    </g>
    <path
      fill="#000"
      fillOpacity={0.5}
      d="M53.75 113H27.612a3.01 3.01 0 0 0-3.016 3c0 1.657 1.35 3 3.016 3H53.75a3.01 3.01 0 0 0 3.016-3c0-1.657-1.35-3-3.016-3"
    />
    <path
      fill="#000"
      fillOpacity={0.2}
      d="M71.846 126H27.612a3.01 3.01 0 0 0-3.016 3c0 1.657 1.35 3 3.016 3h44.234a3.01 3.01 0 0 0 3.016-3c0-1.657-1.35-3-3.016-3"
    />
    <g filter="url(#c)">
      <path
        fill="#fff"
        d="M147.245 19H11.527C8.75 19 6.5 21.239 6.5 24v25c0 2.761 2.25 5 5.027 5h135.718c2.776 0 5.026-2.239 5.026-5V24c0-2.761-2.25-5-5.026-5"
      />
    </g>
    <path
      fill="#000"
      fillOpacity={0.5}
      d="M53.75 27H27.612a3.01 3.01 0 0 0-3.016 3c0 1.657 1.35 3 3.016 3H53.75a3.01 3.01 0 0 0 3.016-3c0-1.657-1.35-3-3.016-3"
    />
    <path
      fill="#000"
      fillOpacity={0.2}
      d="M71.846 40H27.612a3.01 3.01 0 0 0-3.016 3c0 1.657 1.35 3 3.016 3h44.234a3.01 3.01 0 0 0 3.016-3c0-1.657-1.35-3-3.016-3"
    />
    <defs>
      <filter
        id="a"
        width={157.771}
        height={47}
        x={43.728}
        y={59}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={3} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_6118_3205"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_6118_3205"
          result="shape"
        />
      </filter>
      <filter
        id="b"
        width={157.771}
        height={47}
        x={0.5}
        y={102}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={3} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_6118_3205"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_6118_3205"
          result="shape"
        />
      </filter>
      <filter
        id="c"
        width={157.771}
        height={47}
        x={0.5}
        y={16}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={3} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_6118_3205"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_6118_3205"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
)

export const AllDone = () => {

  const [loading, setLoading] = React.useState(false);

  return (
    <div style={{
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      padding: '32px 32px'
    }}>
      <SvgComponent style={{ maxHeight: '160px' }} />
      <Typography
        style={{
          color: '#1F1F1F',
          fontSize: 16,
          fontWeight: 500,
          whiteSpace: 'nowrap',
          padding: '12px 0px 4px 0px',
        }}
      >
        You're all caught up!
      </Typography>
      <Typography style={{
        fontWeight: 400,
        fontSize: 13,
        color: '#1F1F1F',
      }}>
        No actions left to do
      </Typography >
    </div>
  );
}
